/**
 * 首页分类按钮
 */
import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { productMobx, mallMobx } from 'mobx/mall'
import { handleEleScrollTo, scrollToPoint } from '@utils'
import { classNames } from '@dt/fe-utils'
import './index.scss'

const CategoryBtns: FC = () => {
  const { categories, selectCategory } = mallMobx
  const [selectNo, setSelectNo] = useState<string>(mallMobx.selectCategoryNo || '')
  const [isFixed, setFixed] = useState<boolean>(false)
  const [btnsOffsetLeft, setBtnsOffsetLeft] = useState<number[]>([])
  useEffect(() => {
    setFixedFun(mallMobx.mallScrollTop)
  }, [mallMobx.mallScrollTop])
  useEffect(() => {
    const listDom = document.querySelectorAll('.mall-category-btn-item')
    let offsetList = []
    let width = 16
    listDom.forEach((item: HTMLElement) => {
      offsetList.push(item.offsetLeft - 16)
      width += item.offsetWidth + 32
    })
    setBtnsOffsetLeft([...offsetList])
    try {
      const wrapDom = document.querySelector('.mall-category-btn-list') as HTMLElement
      wrapDom.style.width = width + 'px'
    } catch (error) {}
  }, [categories])
  // 选择分类
  const handleSelectCategory = (category?: ICategory | string) => {
    mallMobx.selectCategory(category)
    if (typeof category === 'string') {
      setSelectNo('')
    } else {
      setSelectNo(category.no)
    }
    const menuListContent = document.querySelector('.mall-product-template') as any
    let offsetTop = menuListContent?.offsetTop || 0
    if (offsetTop >= 48) {
      offsetTop = offsetTop - 48
    }
    setFixedFun(offsetTop)
    handleEleScrollTo?.({ selector: 'ion-content.mall-container', y: offsetTop })
  }
  // 控制当前点击的按钮居中
  const setScrollToCenter = (index: number) => {
    const centerLeft = window.innerWidth / 3
    const offsetLeft = btnsOffsetLeft[index]
    try {
      const wrapperDom = document.querySelector('.mall-category-btns-wrapper') as any
      scrollToPoint(wrapperDom, { x: offsetLeft - centerLeft, duration: 200 })
    } catch (error) {}
  }
  // 控制分类栏吸附
  const setFixedFun = (offsetTop: number) => {
    if (offsetTop >= 56) {
      setFixed(true)
    } else {
      setFixed(false)
    }
  }

  return (
    <div className={classNames('mall-category-btns-container', { fixed: isFixed })}>
      <div className='mall-category-btns-wrapper'>
        <div className='mall-category-btn-list'>
          <div
            className={classNames('mall-category-btn-item', { active: !selectNo })}
            // style={{ background: colorMap[0] }}
            onClick={() => {
              handleSelectCategory('')
              setScrollToCenter(0)
            }}
          >{i18n.t('mall.allProduct')}
          </div>
          {
            categories.map((item, index) => {
              return (
                <div
                  key={item.no}
                  className={classNames('mall-category-btn-item', { active: selectNo === item.no })}
                  onClick={(e) => {
                    handleSelectCategory(item)
                    setScrollToCenter(index + 1)
                  }}
                >{item.name}
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default observer(CategoryBtns)
